<template>
  <div class="wrapper-action">
    <div
      class="title text-success"
      @click="setPosSection('queues')">
      <i
        class="fas fa-check"
        style="margin-right: 3px;"/>
      {{ getTextTitle }}
    </div>
    <div
      class="add-btn"
      @click="addPosNextQueue">
      <i class="fas fa-plus"/>
    </div>
  </div>
</template>

<script>
import queueButtonMixins from '@/mixins/pos/queueButton'

export default {
  mixins: [queueButtonMixins],
}
</script>

<style scoped>
.wrapper-action {
  display: flex;
  justify-content: space-between;
  border-bottom: solid 1px #F2F2F2;
  font-size: 14px;
  color: #6C7A86;
}
.wrapper-action > div {
  padding: 12px 15px 10px 15px;
  cursor: pointer;
}
.wrapper-action .title {
  flex: 1;
  font-weight: bold;
}
.wrapper-action .add-btn {
  width: 90px;
  border-left: solid 1px #F2F2F2;
  text-align: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/mobile/common/QueueButton.vue